import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

Vue.component('InputIcon',
  () => import('@/components/Form/InputIcon')
)
Vue.component('InputIconUrl',
  () => import('@/components/Form/InputIconUrl')
)
Vue.component('ButtonIcon',
  () => import('@/components/Form/ButtonIcon')
)
Vue.component('IconBtn',
  () => import('@/components/Form/IconBtn')
)
Vue.component('Loader',
  () => import('@/components/Loader')
)

Vue.component('Navbar',
  () => import('@/components/Navbar')
)
Vue.component('UiTooltip',
  () => import('keen-ui/lib/UiTooltip')
)
Vue.component('UiConfirm',
  () => import('keen-ui/lib/UiConfirm')
)
Vue.component('UiTextbox',
  () => import('keen-ui/lib/UiTextbox')
)
Vue.component('UiModal',
  () => import('keen-ui/lib/UiModal')
)
Vue.component('UiCheckbox',
  () => import('keen-ui/lib/UiCheckbox')
)
Vue.component('UiSwitch',
  () => import('keen-ui/lib/UiSwitch')
)
Vue.component('UiSelect',
  () => import('keen-ui/lib/UiSelect')
)
Vue.component('Dropdown',
  () => import('@/components/Dropdown')
)

Vue.component('HeaderPage',
  () => import('@/components/Layout/HeaderPage')
)
Vue.component('ImageProduct',
  () => import('@/components/ImageProduct')
)
Vue.component('ContentE',
  () => import('@/components/Layout/ContentE')
)
Vue.component('SectionContainer',
  () => import('@/components/Layout/SectionContainer')
)
Vue.component('ImagePreviewE',
  () => import('@/components/Form/ImagePreview')
)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
